import React, { useContext } from 'react';

import styled from '@emotion/styled';

import ModalCloseIcon from '../Icons/ModalCloseIcon';
import { ModalContext } from './ModalContext';

interface ModalContainerProps {
  children: React.ReactNode;
  label?: string | React.ReactNode;
  description?: string;
  width?: string;
  successComponent?: () => React.ReactNode;
  showSuccessComponent?: boolean;
  // setShowSuccessComponent?: (...args: any) => void;
  removeTitleAndControl?: boolean;
  removeCloseIcon?: boolean;
  handleCloseIconClick?: () => void;
}
const ModalContainer: React.FC<ModalContainerProps> = ({
  children,
  label,
  description,
  successComponent,
  showSuccessComponent,
  // setShowSuccessComponent,
  handleCloseIconClick,
  removeCloseIcon = false,
  removeTitleAndControl = false,
  width = '520px',
}) => {
  const modalContext = useContext(ModalContext);

  const onClickCancel = (e: any) => {
    modalContext?.setShowModal(false);
    handleCloseIconClick && handleCloseIconClick();
    // setShowSuccessComponent && setShowSuccessComponent(false);
  };

  return (
    <Container
      width={width}
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
      }}
    >
      {showSuccessComponent ? (
        successComponent && successComponent()
      ) : (
        <>
          {!removeTitleAndControl && (
            <HeaderSection>
              <HeaderArea>
                <Header>{label}</Header>
                {!removeCloseIcon && (
                  <IconContainer onClick={onClickCancel}>
                    <ModalCloseIcon />
                  </IconContainer>
                )}
              </HeaderArea>

              {description && <Description>{description}</Description>}
            </HeaderSection>
          )}
          {children}
        </>
      )}
    </Container>
  );
};

export default ModalContainer;

const Container = styled.div<{ width: string }>`
  display: flex;
  flex-direction: column;
  padding: 60px;
  border-radius: 16px;
  background-color: white;
  width: ${({ width }) => width};
  /* width: fit-content; */
  gap: 24px;
  margin-top: 146px;
  margin-bottom: 146px;

  @media (max-width: 884px) {
    padding: 32px;
    margin-right: 25px;
    margin-left: 25px;
    width: min(${({ width }) => width}, calc(100vw - 50px));
  }

  @media (max-width: 480px) {
    width: 90vw;
    padding: 24px;
  }
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* border: 2px solid red; */
`;

const HeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 1px solid red; */
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.primaryTextColor};
`;

const IconContainer = styled.div`
  /* border: 2px solid red; */
  cursor: pointer;
`;

const Description = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;
